import { render } from "./thread.vue?vue&type=template&id=1c0e6e4d"
import script from "./thread.vue?vue&type=script&lang=js"
export * from "./thread.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__